/* eslint-disable react/no-array-index-key */
import FulfilledTitle from '@assets/fulfilled-title.svg';
import UnfulfilledTitle from '@assets/unfulfilled-title.svg';
import {
  PageTitle,
  Merchandise,
  Panel,
  SplitLine,
  BottomButtons,
  ItemList,
  ModalForNoTrackNumber,
} from '@components';
import { useTheft } from './hooks';
import { PackageRadioGroup } from './package-radio-group';
import classes from '../choose/index.module.css';

const TITLE_TEXT = 'Protected item(s)';

export const Theft = () => {
  const {
    fulfilledItems,
    unFulfilledItems,
    orderName,
    isBtnDisable,
    delayPackageId,
    specialPlatform,
    open,
    fulfillmentInfo, merchantId,
    onChange,
    onClickTitle,
    onClickContinue,
    onClickBack,
    handleClose,
    handleOK,
    handleShippingClick,
  } = useTheft();
  const getFulfilledBlock = () => {
    if (!fulfilledItems?.length) {
      return null;
    }
    return (
      <Panel icon={FulfilledTitle} title="Fulfilled" className={classes.ful_panel}>
        <PackageRadioGroup
          orderName={orderName}
          onChange={onChange}
          onClickTitle={onClickTitle}
          packageList={fulfilledItems}
          delayPackageId={delayPackageId}
          specialPlatform={specialPlatform}
          handleShippingClick={handleShippingClick}
          merchantId={merchantId}
        />
      </Panel>
    );
  };

  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }

    return (
      <Panel icon={UnfulfilledTitle} title="Unfulfilled" className={classes.unful_panel}>
        {unFulfilledItems.map((item, index) => (
          <ItemList item={item} itemKey={`${item.lineItemId}_${index}`}>
            <div>
              {index === 0 ? null : <SplitLine />}
              <Merchandise item={item} />
            </div>
          </ItemList>
        ))}
      </Panel>
    );
  };

  return (
    <section className={classes.content}>
      <PageTitle title={TITLE_TEXT} subTitle="Please choose which package is stolen." />
      {getFulfilledBlock()}
      {getUnfulfilledBlock()}
      <BottomButtons
        isContinueDisabled={isBtnDisable}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      // isContinueLoading={isLoading}
      />
      {open && (
        <ModalForNoTrackNumber
          open={open}
          handleClose={handleClose}
          handleOK={handleOK}
          currentFulfillmentId={fulfillmentInfo.fulfillmentId}
        />
      )}
    </section>
  );
};
